<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import IMGS from '../src/utils/preLoadImg'
export default {
  name: 'App',
  data() {
    return {
      images: IMGS,
      currentImages: [],
      cacheImages: [],
      preLoadEvent: null,
      index: 0,
      size: 10,
    }
  },
  mounted() {
    let that = this;
    requestAnimationFrame(stamp => {
      that.preLoadEvent = setInterval(function () {
        that.currentImages = that.images.slice(that.index * that.size, (that.index + 1) * that.size)
        for (let i = 0; i < that.currentImages.length; i++) {
          let a = new Image();
          a.src = that.currentImages[i];
          that.cacheImages.push(a);
        }
        that.index++;
        if (that.index * that.size >= that.images.length) {
          clearInterval(that.preLoadEvent)
        }
      }, 500)
    })
  },
}
</script>

<style>
html {
  font-size: 14px;
}

.img-loader {
  width: 0;
  height: 0;
}

.img-loader img {
  width: 0;
  height: 0;
}

@font-face {
  font-family: 'nike';
  src: url('../static/fonts/TradeGothicforNike365-BdCn.ttf') format('truetype')
}

/* @font-face {
  font-family: 'nike-ch';
  src: url('../static/fonts/PingFangRegular.ttf') format('truetype')
} */

#app {
  font-family: 'nike', 'Avenir', Helvetica, Arial, sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
}

html::-webkit-scrollbar {
  width: 8px;
  height: 0px;
}

html::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  cursor: default;
  user-select: none;
  font-family: 'nike' !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue